<!-- eslint-disable vue/require-default-prop -->
<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="wrapper-container" :class="{ 'mx-auto': print }">
        <div class="card shadow-sm p-5 border-0">
            <div role="radiogroup" aria-label="Select Product">
                <h2 class="text-center text-primary form-section__title">
                    <span v-for="(item, index) in $root.t('step2.selectProduct')" :key="index">
                        {{ item }} <br />
                    </span>
                </h2>
                <div v-if="!print" class="p-2 text-center d-flex justify-content-center" style="flex-wrap: wrap">
                    <div v-for="(p, index) in products" :key="index">
                        <input
                            :id="'product-selected-' + index"
                            type="radio"
                            :name="'product-selected-' + index"
                            class="btn-check"
                            :class="[index === $formData.selectedProductIndex ? 'btn-primary' : 'btn-light']"
                            :checked="index === $formData.selectedProductIndex ? true : false"
                            @click="selectProduct(index, p)"
                        />
                        <label
                            class="btn m-1 fs-15px"
                            :for="'product-selected-' + index"
                            :class="[index === $formData.selectedProductIndex ? 'btn-primary text-light fw-bold' : '']"
                            style="border-color: #1076bc"
                        >
                            <span>{{ p.productName }}</span>
                            <span v-if="currentLocale != 'en'">
                                <br />
                                {{ p.productNameTranslation }}
                            </span>
                        </label>
                    </div>
                </div>
                <h5 v-else class="p-2 text-center">{{ $t('step2.product') }} {{ getProductPrint(products) }}</h5>
            </div>

            <div v-if="showPackage">
                <EvolutionHealthPackage
                    class="mb-5"
                    :product-index="$formData.selectedProductIndex"
                    :print="print"
                    @update-quote-event="updateQuote()"
                />
            </div>

            <div v-if="!print" class="mt-10">
                <div class="text-center">
                    <h5>
                        <span v-for="(item, index) in $root.t('step2.selectUnderwritingType')" :key="index">
                            {{ item }} <br />
                        </span>
                    </h5>
                </div>
                <div class="alert alert-warning" role="alert">
                    <div v-for="(item, index) in $root.t('step2.selectUnderwritingDesc')" :key="index">
                        <span class="text-danger"> {{ item.pleaseNote }} </span>{{ item.desc }}
                        &nbsp;
                        <i class="fas fa-question-circle me-2 text-primary" />
                        <a href="#" role="button" @click="showHelperModal()">
                            {{ item.helpMeChoose }}
                        </a>
                    </div>
                </div>
                <div class="text-center">
                    <div class="row g-3" role="radiogroup" aria-label="Select Underwriting Type">
                        <div
                            v-for="underwriting in $optionData.underWritingTypes"
                            :key="underwriting.value"
                            class="col-md-6 bd-highlight"
                        >
                            <Input
                                :id="'underwritingType' + underwriting.value"
                                v-model="form.underwritingTypeId"
                                class-name="btn-check"
                                input-type="radio"
                                :name="'underwritingType' + underwriting.value"
                                :checked-value="underwriting.value"
                                @click.native="selectUnderwritingType()"
                            />
                            <label
                                class="btn btn-outline-primary btn-lg w-100"
                                :for="'underwritingType' + underwriting.value"
                                v-html="underwriting.text.replace('-', '<br>')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AppModal
            :title="helperTitle"
            :content="helperContent"
            :is-open="openHelperModal"
            :size="3"
            @onClose="openHelperModal = false"
        />
    </div>
</template>

<script>
import EvolutionHealthPackage from './EvolutionHealthPackage.vue'
import AppModal from '../shared/Modal.vue'
import quoteService from '../../api/services/quoteService.js'
import { getSummaryData } from '../../data/formData.js'
import helper from '../../utils/helper.js'

export default {
    name: 'EvolutionHealth',
    components: {
        EvolutionHealthPackage,
        AppModal,
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        previousStep: {
            type: Number,
        },
        // print false thi ko update quote
        print: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: this.$formData,
            products: this.$quote.products,

            helperTitle: '',
            helperContent: '',
            openHelperModal: false,

            product: this.$formData.product,
            nationalities: this.$optionData.nationalities,

            isUpdateQuoteLoading: false,
            showPackage: true,
            currentLocale: this.$locale,
        }
    },
    computed: {
        underWritingType() {
            return this.$optionData.underWritingTypes.find((v) => v.value === this.form.underwritingTypeId).text
        },
    },
    mounted() {
        // update underwriting type
        if (this.previousStep == 3) {
            this.updateQuote()
        }

        if (this.previousStep == 1) {
            setTimeout(() => {
                quoteService
                    .getUnderwritingTypesAsync(
                        this.$formData.getCurrentFormData(),
                        this.$optionData,
                        this.$quote,
                        this.$locale,
                    )
                    .then((res) => {
                        this.$optionData.underWritingTypes = res
                        this.$forceUpdate()
                    })
            }, 10)
        }
    },
    unmounted() {
        this.updateQuote()
    },
    methods: {
        /**
         * Clear underwriting question of not selected FMU type
         */
        selectUnderwritingType() {
            // policy holder
            if (this.$formData.underwritingQuestions.length) this.$formData.underwritingQuestions = []

            // family
            if (this.$formData.familyMembers.length) {
                this.$formData.familyMembers.forEach((v) => {
                    v.underwritingQuestions = []
                })
            }
        },

        selectProduct(index, product) {
            this.$formData.selectedProductIndex = index
            this.$formData.product.productId = product.productID
            this.product.productId = product.productID
            this.$forceUpdate()
        },

        async updateQuote(/*callback*/) {
            try {
                this.lockControl(true)

                try {
                    await this.$root.callUpdateQuote()
                } catch (e) {
                    return
                }

                this.showPackage = false
                setTimeout(() => {
                    this.showPackage = true
                }, 200)

                this.$toast.open({
                    message: helper.multiLanguageDisplay(this.$root.t('notify.quoteUpdated')),
                    type: 'success',
                    pauseOnHover: true,
                })

                // Update $formData
                getSummaryData(this)
            } catch (error) {
                console.error(error)
            } finally {
                var updateBtns = document.getElementsByName('updateQuote')
                updateBtns.forEach((el) => {
                    el.disabled = false
                })
                this.lockControl(false)
            }
        },

        validPackageValue(quote) {
            quote.products.forEach((product) => {
                product.areasOfCover = product.areasOfCover.filter(function (area) {
                    var isValid = false
                    area.levelsOfCover.forEach((l) => {
                        if (l.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.length > 0) {
                            isValid = true
                        }
                    })

                    return isValid
                })
            })
        },

        lockControl(status) {
            this.isUpdateQuoteLoading = status
            document.getElementById('previousBtn').disabled = status
            document.getElementById('nextBtn').disabled = status
        },

        showHelperModal() {
            this.helperTitle = helper.multiLanguageDisplay(this.$root.t('popup.underwriting'))
            this.helperContent = helper.multiLanguageDisplay(this.$root.t('popup.underwritingContent'))
            this.openHelperModal = true
        },

        // Print helper func
        getProductPrint(products) {
            return products.find((p) => p.productID === this.$formData.product.productId).productName
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-primary {
    color: #fff;
    background-color: #0a58ca;
    border-color: #0a58ca;
}
</style>
